import { bytesToUnitObject } from '@/common/utils/formatter.number';

export const bytesToMB = (bytes?: number): number => {
  if (!bytes) {
    return 0;
  }
  const result = bytesToUnitObject(bytes, { maxPow: 2, minPow: 2 });
  return typeof result === 'string' ? 0 : Math.round(result.valueNumeric);
};

export const isFiniteNumber = (value?: number | null): value is number => typeof value === 'number' && Number.isFinite(value);

export const toSeconds = (durationMs: number): number => Number((durationMs / 1000).toFixed(2));

export const assignIfFinite = (
  properties: Record<string, unknown>,
  key: string,
  value?: number | null
): void => {
  if (isFiniteNumber(value)) {
    properties[key] = value;
  }
};

export const calculateThroughputKbps = (
  fileSizeBytes: number,
  durationMs: number,
  success: boolean
): number => {
  if (!success || !fileSizeBytes || !durationMs || durationMs <= 0) {
    return 0;
  }

  const fileSizeBits = fileSizeBytes * 8;
  const durationSeconds = durationMs / 1000;
  const bitsPerSecond = fileSizeBits / durationSeconds;
  const kilobitsPerSecond = bitsPerSecond / 1024;

  return Math.round(kilobitsPerSecond);
};
